module.exports = __webpack_public_path__ + "static/media/portrait.70222911.svg";